import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../App.styles";
import Modal from "./Modal";
import Textarea from "./Textarea";
import Spinner from "./Spinner";

const ModalGeneratePhoto = ({
    onDismiss,
    show,
    loading,
    createAiPhoto,
    stickerify = false,
    initialPrompt = "",
}) => {
    const { t } = useTranslation()
    const [modalValue, setModalValue] = useState({ prompt: initialPrompt })
    const onSave = e => {
        e.preventDefault()
        const { prompt } = modalValue
        const generation = createAiPhoto(prompt)
        handleDismiss()
        generation?.catch?.(() => {})
    }
    const handleDismiss = () => {
        setModalValue({ prompt: '' })
        onDismiss()
    }

    useEffect(() => {
        if (show) {
            setModalValue({ prompt: initialPrompt || '' })
        }
    }, [initialPrompt, show])

    return (
        <Modal onDismiss={handleDismiss} show={show} size="lg" className="modal--html form-clean">
            <div className="modal-title px-3 py-2">
                <span dangerouslySetInnerHTML={{ __html: stickerify ? t('AI Generated Sticker') : t('AI generated photo') }} />
            </div>
            <div className="modal-body px-3 pb-3">
                <p dangerouslySetInnerHTML={{
                    __html: stickerify
                        ? t(`Ask our AI to create a sticker for your game/challenge. Tell it what to create. For example, "Cartoon confetti explosion".`)
                        : t(`Ask our AI to create a photo for your game/challenge.
                Tell it what to create. For example, "A photo of a dog wearing a sombrero."`)
                }} />
                <p>{t('Generation will continue in the background and can take up to 5 minutes. The image will appear here when it is ready.')}</p>
                <Textarea
                    name="prompt"
                    useQuery={() => [modalValue, setModalValue]}
                    mode="clean"
                    rows="5"
                    disabled={loading}
                />
            </div>
            <div className="modal-footer">
                {
                    !loading && (
                        <Button disabled={loading} className="btn--flat" data-dismiss="modal" onClick={handleDismiss} outline>
                            {t('Cancel')}
                        </Button>
                    )
                }
                <Button disabled={loading} className="btn--flat" data-dismiss="modal" onClick={onSave} color="primary">
                    {stickerify ? t('Generate Sticker') : t('Generate Photo')} {loading ? <Spinner size="0.875rem" /> : null}
                </Button>
            </div>
        </Modal>
    )
}

export default ModalGeneratePhoto
